'use client';

import { usePathname } from 'next/navigation';
import React, { useMemo } from 'react';

import type { NavBar } from '@/api/types/navigationTypes';
import { Header, type NavigationLink } from '@/components/Header/Header';
import { signIn, signInEmployee, signInMvpd } from '@/features/auth/signin';

interface AnonymousHeader {
  brandIcon?: string;
  subNavBar?: NavBar;
  hasSignIn?: boolean;
  color?: 'white' | 'secondary';
  children?: React.ReactNode;
  className?: string;
}

export function AnonymousHeader(props: AnonymousHeader): React.ReactNode {
  const { className, brandIcon, subNavBar, color = 'secondary', children } = props;
  const pathname = usePathname();
  const isEmployee = pathname.startsWith('/employee');

  const ctas = useMemo((): NavigationLink[] => {
    return [
      {
        title: 'Sign In',
        className: 'text-white underline text-[16px] font-FoxOneAeroBold pr-0 md:pr-[16px]',
        onClick: isEmployee ? signInEmployee : signIn,
        variant: 'transparent',
      },
      {
        title: 'TV Provider',
        className: 'text-white underline text-[16px] font-FoxOneAeroBold hidden md:inline-block',
        onClick: signInMvpd,
        variant: 'transparent',
      },
    ];
  }, [isEmployee]);

  const isSearchActive = subNavBar?.subitems?.some((item) => item.item_key === 'search') ?? false;
  const icon = isEmployee ? 'brand-fox-one-employee' : brandIcon;

  return (
    <Header
      className={className}
      brandIcon={icon}
      logoLink="/"
      ctas={ctas}
      isFixed
      color={color}
      isScrollTransition={false}
      subNavBar={subNavBar}
      isSearchActive={isSearchActive}
    >
      {children}
    </Header>
  );
}
